import { NgModule } from '@angular/core';
import { SABISDynamicformComponent } from './sabis-dynamicform/sabis-dynamicform.component';



@NgModule({
  declarations: [
    SABISDynamicformComponent
  ],
  imports: [
  ],
  exports: [
    SABISDynamicformComponent
  ]
})
export class SABISDynamicFormModule { }
